const closeButtonA11yLabel = {
  closeButtonAriaLabel: 'Close',
};

const carouselA11yLabels = {
  previousAriaLabel: 'Previous',
  nextAriaLabel: 'Next',
};

export const defaultA11yLabels = {
  ...closeButtonA11yLabel,
  ...carouselA11yLabels,
};
